<template>
    <div>
        <myHeader />
        <div class="web-body">
            <div class=" " style="margin-bottom: 200px">
                <div class="row clearfix product-box" style="padding-left:15px;">

                    <div
                        style="width: 721px;margin-top:87px;display: flex;justify-content: space-between;flex-direction: row;">
                        <div style="display: flex;align-items: center;flex-direction: row;">
                            <img src="../assets/images/icon_dxdzz.png" style="width:70px;" />
                            <p style="
                            margin: 0 0 0 27px;
                        font-family: Noto Sans SC-Bold, Noto Sans SC;
                        font-weight: bold;
                        color: #000000;
                        line-height: 50px;
                        font-size: 30px;
                        -webkit-background-clip: text;">
                                点消大作战
                            </p>
                        </div>

                        <div style="width: 168px;
                            height: 46px;
                            background: linear-gradient(#51EAFC 0%, #27909C 100%);
                            border-radius: 50px 50px 50px 50px;
                            opacity: 1;
                            display: flex;
                            justify-content: center;
                            align-self:center;
                            align-items: center;">
                            <a href="https://static.zuiqiangyingyu.net/Android/dxdzz-white-v1.0.0.apk"
                                style="
                            margin:0px;
                                font-size: 20px;
                                font-family: Noto Sans SC-Bold, Noto Sans SC;
                                font-weight: bold;
                                color: #ffffff;
                                line-height: 30px;
                                -webkit-background-clip: text;">
                                立即下载
                            </a>
                        </div>
                    </div>

                    <div style="
                    width: 721px;
                    height: 223px;
                    background: #FAFAFA;
                    border-radius: 20px 20px 20px 20px;
                    opacity: 1;
                    padding-left: 30px;
                    padding-right: 30px;
                    margin-top: 46px;
                    display: flex;
                    justify-content: center;
                    align-items: center">
                        <p style="
                        margin:0px;
                        font-size: 16px;
                        font-family: Noto Sans SC-Regular, Noto Sans SC;
                        font-weight: 400;
                        color: #676262;
                        line-height: 30px;
                        -webkit-background-clip: text;">
                            点消大作战，是一款有趣的手机消除游戏，它十分容易上手，只需手指轻轻点击相邻同色小动物，即可完成消除，是解压游戏的不二之选。它适合各个不同年龄段的玩家体验，它丰富有趣的关卡能给玩家带来不一样的游戏体验，让你在享受到消除玩法带给你的无限快乐的时候，还可以感受炫酷的消除特效，赢得丰厚的奖励，没有时间限制，达到每关目标分数即可过关，得分越高，获得的道具也更多。快来邀请你的好友一起来加入点消大作战，感受不一样的趣味挑战快乐吧！
                        </p>
                    </div>
                    <img src="../assets/images/game_screenshot.png" style="width:194px;position:absolute;top: 74px;right: 0px;" />
                </div>
            </div>
        </div>

        <myFooter />
    </div>
</template>
<script>
import myFooter from './myFooter';
import myHeader from './myHeader';
export default {
    components: {
        myFooter, myHeader
    }
}
</script>



// WEBPACK FOOTER //
// src/components/product.vue